import React from 'react';

function CircleSvg() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='159'
			height='330'
			viewBox='0 0 159 330'
		>
			<defs>
				<clipPath id='clip-path'>
					<path
						fill='#aaa'
						stroke='#707070'
						strokeWidth='2'
						d='M0 0H159V330H0z'
						data-name='Rectangle 11265'
						transform='translate(3496.387 -9489.553)'
					></path>
				</clipPath>
			</defs>
			<g
				clipPath='url(#clip-path)'
				data-name='Mask Group 6'
				opacity='0.15'
				transform='rotate(180 1827.694 -4579.776)'
			>
				<path
					fill='#aaa'
					d='M151.674 66.915a84.759 84.759 0 1084.759 84.759 84.855 84.855 0 00-84.759-84.759m0-66.915A151.674 151.674 0 110 151.674 151.674 151.674 0 01151.674 0z'
					data-name='Path 3673'
					transform='translate(3503.609 -9473.976)'
				></path>
			</g>
		</svg>
	);
}

export default CircleSvg;
